import { RSAA } from 'redux-api-middleware';

export const MEMBERS_IS_FETCHING = 'MEMBERS_IS_FETCHING';
export const MEMBERS_GET_LIST_SUCCESS = 'MEMBERS_GET_LIST_SUCCESS';
export const MEMBERS_API_ERROR = 'MEMBERS_API_ERROR';
export const MEMBERS_GET_SUCCESS = 'MEMBERS_GET_SUCCESS';
export const MEMBERS_ID_CARD_REQUEST = 'MEMBERS_ID_CARD_REQUEST';
export const MEMBERS_ID_CARD_POST_SUCCESS = 'MEMBERS_ID_CARD_POST_SUCCESS';
export const MEMBERS_CLAIMS_IS_FETCHING = 'MEMBERS_CLAIMS_IS_FETCHING';
export const MEMBERS_CLAIMS_GET_LIST_SUCCESS = 'MEMBERS_CLAIMS_GET_LIST_SUCCESS';
export const MEMBERS_CLAIMS_GET_LIST_ERROR = 'MEMBERS_CLAIMS_GET_LIST_ERROR';
export const MEMBERS_CLAIMS_GET_SUCCESS = 'MEMBERS_CLAIMS_GET_SUCCESS';
export const MEMBERS_CLAIMS_GET_ERROR = 'MEMBERS_CLAIMS_GET_ERROR';
export const MEMBERS_CLAIMS_SEND_ISSUE_SUCCESS = 'MEMBERS_CLAIMS_SEND_ISSUE_SUCCESS';
export const MEMBERS_CLAIMS_SEND_ISSUE_ERROR = 'MEMBERS_CLAIMS_SEND_ISSUE_ERROR';
export const MEMBERS_ID_CARD_GET_SUCCESS = 'MEMBERS_ID_CARD_GET_SUCCESS';
export const MEMBERS_SET_PRIVACY_ACKNOWLEDGE_REQUEST = 'MEMBERS_SET_PRIVACY_ACKNOWLEDGE_REQUEST';
export const MEMBERS_REMOVE_PRIVACY_ACKNOWLEDGE_REQUEST = 'MEMBERS_REMOVE_PRIVACY_ACKNOWLEDGE_REQUEST';
export const MEMBERS_CLAIMS_GET_LIST_SUCCESS_OLD = 'MEMBERS_CLAIMS_GET_LIST_SUCCESS_OLD';
export const MEMBERS_HIPAA_FLAG_IS_FETCHING = 'MEMBERS_HIPAA_FLAG_IS_FETCHING';
export const MEMBERS_HIPAA_FLAG_ACK_SENT_SUCCESS = 'MEMBERS_HIPAA_FLAG_ACK_SENT_SUCCESS';
export const MEMBERS_HIPAA_FLAG_ACK_SENT_ERROR = 'MEMBERS_HIPAA_FLAG_ACK_SENT_ERROR';

// Initial State
export const initialState = {
  filters: [
    {
      key: 'subgroupKey',
      label: 'Subgroup ID',
      noSelectionText: 'View All Subgroups',
      isMultiSelect: true,
      options: [],
      selectedValue: null
    },
    {
      key: 'spouseCheck',
      label: 'Spouse',
      isRadio: false,
      values: [
        { value: 0, label: 'Yes' },
        { value: 1, label: 'No' }
      ],
      selectedValue: null
    },
    {
      key: 'statusCheck',
      label: 'Status',
      isRadio: false,
      values: [
        { value: 0, label: 'Active' },
        { value: 1, label: 'Termed' },
        { value: 2, label: 'Deceased' },
        { value: 3, label: 'Rejected' },
        { value: 4, label: 'Pending' }
      ],
      selectedValue: null
    },
    {
      key: 'dependentsCheck',
      label: 'Dependents',
      isRadio: false,
      values: [
        { value: '0', label: '0' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3+' }
      ],
      selectedValue: null
    }
  ],
  searchQuery: null,
  subgroupKey: null,
  defaultSearchParams: {
    perPage: 25,
    page: 1,
    orderBy: 'familyName:asc'
  },
  sorting: {
    prop: '',
    direction: ''
  },
  pagination: {
    page: 1,
    total: 0
  },
  isFetching: false,
  IDCardStatus: 'details',
  items: [],
  selectedItem: null,
  acknowledgedPrivacyFlags: [],
  claims: {
    items: [],
    selectedItem: null,
    isFetching: false,
    error: null,
    contactFormSent: false,
    defaultSearchParams: {
      employeeId: null,
      perPage: 10,
      page: 1,
      orderBy: 'statusDate:desc'
    },
    pagination: {
      page: 1,
      total: 0
    },
    sorting: {
      prop: 'statusDate',
      direction: 'asc'
    }
  },
  error: null
};

// --> Members actions
export const getMembersList = queryString => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_EMPLOYEE',
      controlAction: 'collection',
      queryString,
      types: [
        MEMBERS_IS_FETCHING,
        {
          type: MEMBERS_GET_LIST_SUCCESS,
          meta: { ...queryString }
        },
        MEMBERS_API_ERROR
      ]
    }
  };
};

export const getMemberDetails = Id => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_EMPLOYEE',
      param: { Id },
      types: [MEMBERS_IS_FETCHING, MEMBERS_GET_SUCCESS, MEMBERS_API_ERROR]
    }
  };
};

export const getMemberClaims = queryString => {
  const splitted = queryString.orderBy.split(':');
  const sortProp = splitted[0];
  const sortDir = splitted[1];
  const extraSortPatterns = {
    familyName: ',givenName:' + sortDir + ',statusDate:desc,id:asc',
    id: '',
    statusDate: ',familyName:asc,givenName:asc',
    status: ',statusDate:desc,familyName:asc,givenName:asc'
  };
  const extraSortPattern = extraSortPatterns[sortProp];
  return {
    [RSAA]: {
      controlKey: 'CTRL_CLAIM',
      controlAction: 'collection',
      queryString: { ...queryString, orderBy: queryString.orderBy + extraSortPattern },
      types: [
        MEMBERS_CLAIMS_IS_FETCHING,
        {
          type: MEMBERS_CLAIMS_GET_LIST_SUCCESS,
          meta: { ...queryString }
        },
        MEMBERS_CLAIMS_GET_LIST_ERROR
      ]
    }
  };
};

export const getMemberClaimsOld = employeeId => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_CLAIM',
      controlAction: 'collection',
      queryString: {
        employeeId,
        perPage: 10,
        page: 1,
        orderBy: 'statusDate:desc'
      },
      types: [MEMBERS_CLAIMS_IS_FETCHING, MEMBERS_CLAIMS_GET_LIST_SUCCESS_OLD, MEMBERS_CLAIMS_GET_LIST_ERROR]
    }
  };
};

export const getMemberClaimDetails = id => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_CLAIM',
      controlAction: 'self',
      param: id,
      types: [MEMBERS_CLAIMS_IS_FETCHING, MEMBERS_CLAIMS_GET_SUCCESS, MEMBERS_CLAIMS_GET_ERROR]
    }
  };
};

export const setRequestIDCard = IDCardStatus => {
  return {
    type: MEMBERS_ID_CARD_REQUEST,
    IDCardStatus
  };
};

export const setAcknowledgedPrivacyFlag = ack => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_HIPAA_FLAG_ACK',
      controlAction: 'bci:add',
      body: ack,
      types: [
        MEMBERS_HIPAA_FLAG_IS_FETCHING,
        { type: MEMBERS_HIPAA_FLAG_ACK_SENT_SUCCESS, payload: ack.memberId },
        MEMBERS_HIPAA_FLAG_ACK_SENT_ERROR
      ]
    }
  };
};

export const removeAcknowledgedPrivacyFlag = dependentId => {
  return {
    type: MEMBERS_REMOVE_PRIVACY_ACKNOWLEDGE_REQUEST,
    dependentId
  };
};

export const postRequestIDCard = member => {
  return {
    [RSAA]: {
      controlKey: 'FROM_INSTANCE',
      controlInstance: member.memberIdCard,
      controlAction: 'bci:submit',
      types: [MEMBERS_IS_FETCHING, MEMBERS_ID_CARD_POST_SUCCESS, MEMBERS_API_ERROR]
    }
  };
};

export const postRequestIDCardOld = id => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_ID_CARD_EMAIL_REMOVE',
      controlAction: 'bci:submit',
      body: {
        memberId: id
      },
      types: [MEMBERS_IS_FETCHING, MEMBERS_ID_CARD_POST_SUCCESS, MEMBERS_API_ERROR]
    }
  };
};

export const sendClaimIssue = claim => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_CLAIM_INQUIRY_REQUEST',
      controlAction: 'bci:submit',
      body: claim,
      types: [MEMBERS_IS_FETCHING, MEMBERS_CLAIMS_SEND_ISSUE_SUCCESS, MEMBERS_CLAIMS_SEND_ISSUE_ERROR]
    }
  };
};

// Reducer
export default (state = initialState, action) => {
  let prop, direction;
  switch (action.type) {
    case MEMBERS_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case MEMBERS_CLAIMS_IS_FETCHING:
      return {
        ...state,
        claims: {
          ...state.claims,
          isFetching: true,
          error: null
        }
      };

    case MEMBERS_GET_LIST_SUCCESS:
      if (action.meta.orderBy) {
        let splitted = action.meta.orderBy.split(':');
        prop = splitted[0];
        if (prop === state.sorting.prop) {
          direction = splitted[1];
        } else {
          direction = 'asc';
        }
      } else {
        prop = '';
      }
      direction = direction === 'asc' ? ':desc' : ':asc';
      const out = {
        ...state,
        isFetching: false,
        error: null,
        items: action.payload.items,
        searchQuery: action.meta && action.meta.search ? action.meta.search : null,
        subgroupSelectedFilter: action.meta && action.meta.subgroupKey ? action.meta.subgroupKey : null,
        filters: [...state.filters].map(e => {
          let selectedValue = action.meta[e.key] ? action.meta[e.key] : null;
          return {
            ...e,
            selectedValue
          };
        }),
        pagination: {
          ...state.pagination,
          page: +action.meta.page,
          total: action.payload.pageCount
        },
        sorting: {
          ...state.sorting,
          prop: prop,
          direction: direction
        }
      };
      return out;

    case MEMBERS_API_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };

    case MEMBERS_GET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        selectedItem: action.payload
      };

    case MEMBERS_ID_CARD_REQUEST:
      return {
        ...state,
        IDCardStatus: action.IDCardStatus
      };

    case MEMBERS_HIPAA_FLAG_ACK_SENT_SUCCESS:
      const found = state.acknowledgedPrivacyFlags.some(el => el === action.payload);
      let acknowledgedPrivacyFlags = found
        ? state.acknowledgedPrivacyFlags
        : [...state.acknowledgedPrivacyFlags, action.payload];
      return {
        ...state,
        acknowledgedPrivacyFlags: acknowledgedPrivacyFlags
      };

    case MEMBERS_REMOVE_PRIVACY_ACKNOWLEDGE_REQUEST:
      acknowledgedPrivacyFlags = state.acknowledgedPrivacyFlags.filter(function (i) {
        return i !== action.dependentId;
      });
      return {
        ...state,
        acknowledgedPrivacyFlags: acknowledgedPrivacyFlags
      };

    case MEMBERS_ID_CARD_POST_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        IDCardStatus: 'sent'
      };

    case MEMBERS_CLAIMS_GET_LIST_SUCCESS:
      let claimProp;
      let claimDirection;
      if (action.meta.orderBy) {
        let splitted = action.meta.orderBy.split(':');
        claimProp = splitted[0];
        if (claimProp === state.claims.sorting.prop) {
          claimDirection = splitted[1];
        } else {
          claimDirection = 'asc';
        }
      }
      claimDirection = claimDirection === 'asc' ? ':desc' : ':asc';

      return {
        ...state,
        claims: {
          ...state.claims,
          items: action.payload.items,
          isFetching: false,
          selectedItem: null,
          contactFormSent: false,
          error: null,
          pagination: {
            page: +action.meta.page,
            total: action.payload.pageCount
          },
          sorting: {
            prop: claimProp,
            direction: claimDirection
          }
        }
      };

    case MEMBERS_CLAIMS_GET_LIST_SUCCESS_OLD:
      return {
        ...state,
        claims: {
          items: action.payload.items,
          isFetching: false,
          selectedItem: null,
          contactFormSent: false,
          error: null
        }
      };

    case MEMBERS_CLAIMS_GET_SUCCESS:
      return {
        ...state,
        claims: {
          ...state.claims,
          isFetching: false,
          error: null,
          selectedItem: action.payload,
          contactFormSent: false
        }
      };

    case MEMBERS_HIPAA_FLAG_ACK_SENT_ERROR:
    case MEMBERS_CLAIMS_GET_LIST_ERROR:
    case MEMBERS_CLAIMS_GET_ERROR:
      return {
        ...state,
        claims: {
          ...state.claims,
          isFetching: false,
          error: action.payload
        }
      };

    case MEMBERS_CLAIMS_SEND_ISSUE_SUCCESS:
      return {
        ...state,
        claims: {
          ...state.claims,
          isFetching: false,
          error: null,
          contactFormSent: true
        }
      };

    case MEMBERS_CLAIMS_SEND_ISSUE_ERROR:
      return {
        ...state,
        claims: {
          ...state.claims,
          isFetching: false,
          error: action.payload,
          contactFormSent: false
        }
      };

    case MEMBERS_ID_CARD_GET_SUCCESS:
      return {
        ...state,
        isFetching: false
      };

    case MEMBERS_HIPAA_FLAG_IS_FETCHING:
      return state;

    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        IDCardStatus: 'details'
      };

    default:
      return state;
  }
};
